module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Watch2-ef11ea004ffa84772a0b48ec907b0b2e.svg";